// app/javascript/channels/agent_channel.js
import consumer from "./consumer"


const subscription = consumer.subscriptions.create({channel: "AgentChannel"}, {
    connected() {
        console.log("AgentChannel:: connected");
        console.log("AgentChannel:: connected");
        console.log("AgentChannel:: connected");
        //  console.log(this);
    },
    received(data) {
        // Create a new event, allow bubbling, and provide any data you want to pass to the "detail" property
        const eventAwesome = new CustomEvent("notification:show", {
            bubbles: true,
            detail: {text: () => data},
        });
        console.log("channel::public", JSON.stringify(data));
    }

})

export default subscription;
// app/javascript/channels/appearance_channel.js